export const useBootstrap = function () {
    return useNuxtApp().$bootstrap;
};